"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OpenOrdersComponent = _interopRequireDefault(require("./OpenOrdersComponent"));
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
var _futuresOrdersSelectors = require("../../../redux/futures/selectors/futuresOrdersSelectors");
var _selectors = require("../../../redux/futures/selectors");
var _actions = require("../../../redux/futures/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps(state) {
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  return {
    data: (0, _futuresOrdersSelectors.futuresOpenOrdersCurrencySelector)(state),
    instruments: instruments,
    fetching: (0, _futuresOrdersSelectors.selectFuturesOpenRequestsLoading)(state),
    selectedInstrument: (0, _selectors.futuresSelectedInstrumentSelector)(state),
    openOrdersStartIndex: 0,
    selectedAccountId: (0, _selectors.selectedAccountIdSelector)(state),
    OMSId: state.user.userInfo.OMSId
  };
};
var mapDispatchToProps = {
  getOpenOrders: _actions.getFuturesOpenOrders,
  cancelOrders: _actions.cancelFuturesOrders,
  resetActivePage: _orderHistoryActions.resetActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_OpenOrdersComponent["default"]);